<template>
  <header class="printable-reward-link-redemption-header">
    <printable-reward-link-redemption-header-logo :url="urlToRenderForLogo" />
  </header>
</template>

<script>
import PrintableRewardLinkRedemptionHeaderLogo from './PrintableRewardLinkRedemptionHeaderLogo'
import { LandingPageCustomization } from '../customization/LandingPageCustomization'

export default {
  name: 'PrintableRewardLinkRedemptionHeader',
  components: {
    PrintableRewardLinkRedemptionHeaderLogo
  },
  props: {
    landingPageCustomization: {
      type: LandingPageCustomization,
      required: false,
      default: null
    }
  },
  computed: {
    urlToRenderForLogo () {
      return this.landingPageCustomization
        ? this.landingPageCustomization.logoImageUrl
        : null
    }
  }
}
</script>

<style lang="scss" scoped>
@import './variables';

.printable-reward-link-redemption-header {
  min-height: 90px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  box-shadow: 0px 2px 4px 0px rgba(126, 126, 126, 0.6);
  width: 100%;
  z-index: $printableRewardLinkRedemptionHeaderZIndex;
}
</style>
